export const MDM_FIELD_DEFAULT_TEXT =
  'Reviewed diagnosis, expected course, treatment plan, and reasons to seek urgent and/or emergent care.  Discharge instructions reviewed.  Caregiver expressed understanding.  All questions were answered, and caregiver is comfortable with discharge plan.';

export const DIAGNOSIS_MAKE_PRIMARY_BUTTON = 'Make Primary';
